import colors from '../../_shared/colors';

export default {
  container: `
    max-width: 500px;
  `,
  alert: `
    margin-bottom: 10px;
  `,
  notificationsContainer: `
    margin-bottom: 20px;
  `,
  groupContainer: `
    margin-bottom: 24px;
  `,
  groupTitle: `
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
    color: #333;
  `,
  notificationRow: `
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px solid #f0f0f0;
    &:last-child {
      border-bottom: none;
    }
  `,
  notificationLabel: `
    font-size: 14px;
    color: #666;
  `,
  warningSwitch: `
    .ant-switch {
      border-color: ${colors.error};
    }
  `,
  error: `
    color: ${colors.error};
  `,
  errorContainer: `
    margin-bottom: 15px;
  `,
};
